<template>
  <div>
    <!-- 开始前：商品须知确认弹窗 -->
    <el-dialog :visible.sync="beginVisible" width="840px" :show-close="false" :close-on-click-modal="false" title=" ">
      <div class="cp-tabs" v-if="products.length > 0">
        <span
          v-for="(p, i) in products"
          :key="p.productId"
          :class="['cp-tab', { active: beginActiveIndex === i }]"
          @click="beginActiveIndex = i"
        >{{ p.productName }}</span>
      </div>
      <div v-for="(p, i) in products" :key="'b-' + p.productId" v-show="beginActiveIndex === i">
        <h3 style="text-align:center;">开始对练前，请了解店铺产品</h3>
        <img v-for="url in p.imageUrls" :key="url" :src="url" class="cp-img" />
      </div>
      <div slot="footer" style="text-align:center;">
        <el-button type="primary" size="medium" @click="onBeginConfirm">我已知晓，确认后进入对练</el-button>
      </div>
    </el-dialog>

    <!-- 训练中：产品须知弹窗 -->
    <el-dialog :visible.sync="orderVisible" width="840px" title="产品须知">
      <div class="cp-tabs" v-if="products.length > 0">
        <span
          v-for="(p, i) in products"
          :key="p.productId"
          :class="['cp-tab', { active: orderActiveIndex === i }]"
          @click="orderActiveIndex = i"
        >{{ p.productName }}</span>
      </div>
      <div v-for="(p, i) in products" :key="'o-' + p.productId" v-show="orderActiveIndex === i">
        <img v-for="url in p.imageUrls" :key="url" :src="url" class="cp-img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CourseProductModal',
  props: {
    courseId: { type: [String, Number], default: null }
  },
  data() {
    return {
      products: [],
      beginVisible: false,
      orderVisible: false,
      beginActiveIndex: 0,
      orderActiveIndex: 0
    };
  },
  mounted() {
    this.fetchProducts();
  },
  watch: {
    courseId() {
      this.fetchProducts();
    }
  },
  methods: {
    fetchProducts() {
      if (!this.courseId) {
        this.$emit('products-fetched', false);
        return;
      }
      this.$http.get(API_ROOT.newcustomer + '/train/courseProduct?courseId=' + this.courseId).then(res => {
        const result = res.data;
        this.products = (result && result.success && result.data) ? result.data : [];
        this.$emit('products-fetched', this.products.length > 0);
      }).catch(() => {
        this.products = [];
        this.$emit('products-fetched', false);
      });
    },
    handleStart() {
      if (this.products.length > 0) {
        this.beginActiveIndex = 0;
        this.beginVisible = true;
      } else {
        this.$emit('confirm');
      }
    },
    showProducts() {
      this.orderActiveIndex = 0;
      this.orderVisible = true;
    },
    onBeginConfirm() {
      this.beginVisible = false;
      this.$emit('confirm');
    }
  }
};
</script>

<style scoped>
.cp-tabs {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 0 10px;
}
.cp-tab {
  background: #ffb452;
  color: #fff;
  padding: 0 12px;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.cp-tab.active {
  background: #d4820f;
}
.cp-img {
  display: block;
  width: 736px;
  height: auto;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/components/CourseProductModal.vue